var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4635 15.0524C12.5877 15.0524 10.3281 12.8134 10.3281 9.9637C10.3281 7.11403 12.5877 4.875 15.4635 4.875C18.3393 4.875 20.5989 7.11403 20.5989 9.9637C20.5989 12.8134 18.3393 15.0524 15.4635 15.0524ZM15.4635 6.91048C13.7175 6.91048 12.3823 8.23354 12.3823 9.9637C12.3823 11.6939 13.7175 13.0169 15.4635 13.0169C17.2095 13.0169 18.5447 11.6939 18.5447 9.9637C18.5447 8.23354 17.2095 6.91048 15.4635 6.91048Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.626 17.0876C21.3179 17.0876 21.1125 16.9859 20.9071 16.7823L18.3394 14.238C17.9285 13.8309 17.9285 13.2202 18.3394 12.8131C18.7502 12.406 19.3665 12.406 19.7773 12.8131L22.345 15.3575C22.7558 15.7646 22.7558 16.3752 22.345 16.7823C22.1396 16.9859 21.9341 17.0876 21.626 17.0876Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0146 17.0895H3.67942C3.06317 17.0895 2.65234 17.4966 2.65234 18.1073C2.65234 18.7179 3.06317 19.125 3.67942 19.125H15.0146C15.6309 19.125 16.0417 18.7179 16.0417 18.1073C16.0417 17.4966 15.6309 17.0895 15.0146 17.0895Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.90538 10.9841H3.67942C3.06317 10.9841 2.65234 11.3911 2.65234 12.0018C2.65234 12.6124 3.06317 13.0195 3.67942 13.0195H6.90538C7.52163 13.0195 7.93246 12.6124 7.93246 12.0018C7.93246 11.3911 7.52163 10.9841 6.90538 10.9841Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.74011 4.87468H3.67942C3.06317 4.87468 2.65234 5.28177 2.65234 5.89242C2.65234 6.50306 3.06317 6.91016 3.67942 6.91016H8.74011C9.35636 6.91016 9.76719 6.50306 9.76719 5.89242C9.76719 5.28177 9.35636 4.87468 8.74011 4.87468Z",
    fill: "#5A5A5A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.8319c0c7378b40728e1d7db232a07283.svg";
export { ForwardRef as ReactComponent };